import React from "react";

function Description() {
  return (
    <>
      <section className="tab_contengt_holder">
        <p className="tab_text">
          Gaurav Pradhan Autograph Collection (GPAC) presents Uri - the
          hand-crafted, pure Copper pitcher from Mittal Craftworks! The pure,
          food-grade Copper bedside pitcher features a built-in tumbler that
          doubles up as its lid. All our Copper products offer innumerable
          health benefits, as prescribed in Bharat's (India's) age-old science
          of Ayurved! Drinking water stored in Copper vessels is said to give
          amazing health benefits and has been recommended by Ayurved, since
          generations! Ayurved recommends to store water overnight in a Copper
          vessel and drink it first thing in the morning, in order to keep very
          good health. Such water is said to be very helpful in balancing all
          the three elements or doshas (Kapha, Vata and Pitta) of the body.
          Storing drinking water in a Copper vessel for more than 8 hours makes
          it rich in antioxidants, anti-bacterial properties, & anti-inflam-
          ematory properties. Copper vessel stored water also aids in weight
          loss, slowing down ageing, reducing joint pains, and helping maintain
          a beautiful skin.
        </p>
      </section>
    </>
  );
}

export default Description;
